<script setup>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
// import appConfig from "../../../app.config";
import Idle from "@/components/traffic-records/idle.vue";
import { onMounted, onUnmounted, computed, defineProps, ref } from 'vue';
// import CropPlateNumberWithMediaViewerVue from "@/components/traffic-records/crop-plate-number-with-media-viewer.vue";
import FloatingTimer from "@/components/FloatingTimer.vue"
import MediaViewer from "@/components/traffic-records/media-viewer.vue"
// import CropPlateNumber from "@/components/traffic-records/crop-plate-number.vue"
import CameraCaptureInfo from "@/components/traffic-records/camera-capture-info.vue"
import EditableInputViolation from "@/components/traffic-records/editable-input-violation.vue";
import InputRegistrationNumber from "@/components/traffic-records/input-registration-number.vue"
import EditableMVFileRecord from "@/components/traffic-records/editable-mv-file-record.vue"
// import NovViewer from "@/components/traffic-records/nov-viewer.vue"
import SaveOrReject from "@/components/traffic-records/save-or-reject.vue"
// import SaveOrRejectInputPhase from "@/components/traffic-records/save-or-reject-input-phase.vue"
// import SaveOrRejectVerifyPhase from "@/components/traffic-records/save-or-reject-verify-phase.vue"
// import ViolationHistory from '@/components/traffic-records/violation-history.vue';
import DisputeTimeline from '@/components/traffic-records/dispute-timeline.vue';
import Swal from 'sweetalert2';
import { useStore } from 'vuex'
// import InputRemarks from '@/components/traffic-records/input-remarks.vue';
// import MvFileRecordDisabled from '@/components/traffic-records/mv-file-record-disabled.vue';
import ViolationInputDisabled from '@/components/traffic-records/violation-input-disabled.vue'
import axios from 'axios';
import { authHeader } from '@/helpers/authservice/auth-header';

const title = ref("Dispute");
const items = ref([
    {
        text: "Home",
    },
    {
        text: "Traffic Records",
    },
    {
        text: "Dispute",
        active: true,
    }
]);

const getDisputeCount = async () => {
    store.dispatch('globals/loading', null, { root: true });

    try {
      const {data} = await axios.get(`/queue/${user.value.id}/dispute-count`, {
        headers: authHeader()
      });

      title.value = `Dispute: ${data.dispute}`;

      store.dispatch('globals/loaded', null, { root: true });
    } catch (err) {
      console.log(err);
      store.dispatch('globals/loaded', null, { root: true });
    }
}

const props = defineProps({
  phase_id:{
    type: Number,
    required: true
  }
});

const store = useStore();

const user = computed(() => store.state.auth.user);
const phases = computed(() => store.state.trafficRecordComponent.queue_components && store.state.trafficRecordComponent.queue_components.phases);
const mount_components = computed(() => store.state.trafficRecordComponent.mount_components);
const loading = computed(() => store.state.globals.loading);
const notification = computed(() => store ? store.state.notification : null)
const is_valid_registration_number = computed(() => store.state.trafficRecordComponent.is_valid_registration_number);
const traffic_record = computed(() => store.state.trafficRecordComponent.traffic_record);
const selected_lane = computed(() => store.state.trafficRecordComponent.selected_lane);
const selected_violation = computed(() => store.state.trafficRecordComponent.selected_violation);
const selected_registration_type = computed(() => store.state.trafficRecordComponent.selected_registration_type);
const selected_motor_vehicle_type = computed(() => store.state.trafficRecordComponent.selected_motor_vehicle_type);
const input_registration_number = computed(() => store.state.trafficRecordComponent.input_registration_number);
const input_remarks = computed(() => store.state.trafficRecordComponent.input_remarks);
const isSubmitted = ref(false);
const mv_file_record = computed(() => store.state.trafficRecordComponent.mv_file_record);
const input_speed_limit = computed(() => store.state.trafficRecordComponent.input_speed_limit);

const setReloadInterval = () => window.setInterval(() =>  {
  if (notification.value && notification.value.message && notification.value.message === 'No traffic record to queue.') {
    reloadPage();
  }
  clearReloadInterval(setReloadInterval);
}, 30000);

const clearReloadInterval = (interval) => window.clearInterval(interval);

onMounted(async ()=>{
  await store.dispatch('notification/clear', null, { root: true });
  store.commit('trafficRecordComponent/SET_PHASE_ID','dispute');
  store.commit('trafficRecordComponent/SET_USER_ID',user.value.id);
  await getTrafficRecordDispute();
  await getDisputeCount();
  setReloadInterval();
});

const getTrafficRecordDispute = () => store.dispatch('trafficRecordComponent/getTrafficRecordDispute');

onUnmounted(()=>{
    store.dispatch('trafficRecordComponent/resetState');
    store.dispatch('notification/clear', null, { root: true });
});

const save = async () => {
  if(!is_valid_registration_number.value.is_valid){
    return Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Please enter a valid Registration Number.'
    })
  }

  // if(mv_file_record.value && mv_file_record.value.stradcom && mv_file_record.value.stradcom.selected){
  //   if(!mv_file_record.value.stradcom.city_id){
  //     return Swal.fire({
  //       icon: 'error',
  //       title: 'Oops...',
  //       text: 'Please select a city in MV File Record.'
  //     })
  //   }
  // }

  // if(mv_file_record.value && mv_file_record.value.dermalog && mv_file_record.value.dermalog.selected){
  //   if(!mv_file_record.value.dermalog.city_id){
  //     return Swal.fire({
  //       icon: 'error',
  //       title: 'Oops...',
  //       text: 'Please select a city in MV File Record.'
  //     })
  //   }
  // }

  let phase_3_mv_file_record_has_record = false;

  if(mv_file_record.value && mv_file_record.value.stradcom && mv_file_record.value.stradcom.selected){
    phase_3_mv_file_record_has_record = true;
  }
  if(mv_file_record.value && mv_file_record.value.dermalog && mv_file_record.value.dermalog.selected){
    phase_3_mv_file_record_has_record = true;
  }

  if(!phase_3_mv_file_record_has_record){
    if(!mv_file_record.value.dermalog.city_id){
      return Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Cannot proceed without MV File Record.'
      })
    }
  }

  let confirm_message = 'Do you want to proceed in updating this record?';
  if(props.phase_id == 2 && input_registration_number.value != traffic_record.value.registration_number){
     confirm_message = `Registration Number (${input_registration_number.value}) does not matched from Input Phase (${traffic_record.value.registration_number}). Do you still want to proceed in updating this record?`
  }

  const confirm = await Swal.fire({
    icon: 'warning',
    title: 'Continue?',
    text: confirm_message,
    showCancelButton: true,
    confirmButtonText: 'Proceed',
  })

  if (!confirm.isConfirmed) {
    return;
  }

  let inputs = {
    phase_id: traffic_record.value.phase_id,
  }

  if(selected_lane.value){
    inputs.lane = selected_lane.value
  }
  if(input_speed_limit.value){
    inputs.speed_limit = input_speed_limit.value
  }
  if(selected_violation.value){
    inputs.violation_penalty_id = selected_violation.value
  }
  if(selected_registration_type.value){
    inputs.registration_type_id = selected_registration_type.value
  }
  if(selected_motor_vehicle_type.value){
    inputs.motor_vehicle_type_id = selected_motor_vehicle_type.value
  }
  if(input_registration_number.value){
    inputs.registration_number = input_registration_number.value
  }
  if(input_remarks.value){
    inputs.remarks =input_remarks.value
  }

  if(mv_file_record.value && mv_file_record.value.stradcom && mv_file_record.value.stradcom.selected){
    inputs.stradcom_mv_file_record_id = mv_file_record.value.stradcom.id
    if(mv_file_record.value.stradcom.current_owner_name){
      inputs.stradcom_mv_file_record_input_name = mv_file_record.value.stradcom.current_owner_name
    }
    if(mv_file_record.value.stradcom.incomplete_address){
      inputs.stradcom_mv_file_record_input_incomplete_address = mv_file_record.value.stradcom.incomplete_address
    }
    if(mv_file_record.value.stradcom.city_id){
      inputs.stradcom_mv_file_record_selected_city_id = mv_file_record.value.stradcom.city_id
    }
  }

  if(mv_file_record.value && mv_file_record.value.dermalog && mv_file_record.value.dermalog.selected){
    inputs.dermalog_mv_file_record_id = mv_file_record.value.dermalog.id
    if(mv_file_record.value.dermalog.current_owner_name){
      inputs.dermalog_mv_file_record_input_name = mv_file_record.value.dermalog.current_owner_name
    }
    if(mv_file_record.value.dermalog.incomplete_address){
      inputs.dermalog_mv_file_record_input_incomplete_address = mv_file_record.value.dermalog.incomplete_address
    }
    if(mv_file_record.value.dermalog.city_id){
      inputs.dermalog_mv_file_record_selected_city_id = mv_file_record.value.dermalog.city_id
    }
  }

  try {
    isSubmitted.value = true;
    store.dispatch('globals/loading', null, { root: true });

    await axios.post(`/traffic_record_component/save_or_reject/save/${traffic_record.value.id}`,inputs,{
        headers: authHeader()
    });
    isSubmitted.value = false;
    store.dispatch('globals/loaded', null, { root: true });

    reloadPage();

  } catch (error) {
    console.log(error);
    isSubmitted.value = false;
    store.dispatch('globals/loaded', null, { root: true });

    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: error.response.data.message,
    })
  }
  
}

const reloadPage = () => {
  window.location.reload(true);
}

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <Idle />
    <div class="container" v-if="notification && notification.message && notification.message === 'No traffic record to queue.'">
      <div class="row justify-content-center">
        <div class="col-md-10 col-lg-8">
            <div class="card p-3">
            <div class="card-body row justify-content-center">
              <div class="col-md-1">
                <img width="50" src="@/assets/images/animated-traffic-light.gif" />
              </div>
              <div class="offset-1 col-md-6">
                <h3>{{ notification.message }}</h3>
                <p>Please wait for at least 30 seconds or click the "Refresh" button below.</p>
                <button @click="reloadPage" class="btn btn-secondary rounded-pill waves-effect waves-light">
                  <i class="mdi mdi-refresh"></i>
                  Refresh
                </button>
              </div>
              <!-- <p class="lead m-4">{{ notification.message }} </p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-else-if="notification && notification.message && notification.message !== 'No traffic record to queue.'">
        <div class="row justify-content-center">
          <div class="col-md-6">
            <div class="card p-3 text-center">
              <div class="card-body row justify-content-center">
                <img width="250" class="mb-3" src="@/assets/images/error500.png" />
                <h3>There's something wrong in our end. Please try again later.</h3>
                <p class="lead m-4">Error: {{ notification.message }}</p>
                  <a href="/" class="btn btn-info rounded-pill waves-effect waves-light">
                  <i class="mdi mdi-arrow-left"></i>
                  Go back to Dashboard
                </a>
              </div>
            </div>
          </div>
        </div>
    </div>

    <div v-if="notification && notification.messages.length > 0">
        <b-alert v-for="(message, index) in notification.messages" :key="index"
            show :variant="notification.type" class="fade show" role="alert">
            {{ message }}
        </b-alert>
    </div>
    <form v-if="mount_components" @submit.prevent="save">
      <b-overlay v-show="!loading" :show="loading">
        <div class="row">
            <!-- <CropPlateNumberWithMediaViewerVue /> -->
            <FloatingTimer/>
            <MediaViewer class="col-md-12 col-lg-12 col-xl-8" />
            <div class="col-md-12 col-lg-12 col-xl-4 flex-xl-column row">
              <!-- <ViolationHistory class="col-lg-12 col-xl-12" /> -->
              <CameraCaptureInfo :lgu_has_speed_violation="[2,5,6]" class="col-lg-12 col-xl-12"/>
              <InputRegistrationNumber class="col-lg-12 col-xl-12" :enabled_input="false"/>
              <ViolationInputDisabled v-if="traffic_record.violation_penalties && traffic_record.violation_penalties[0].violation_penalty_id != 0" class="col-lg-12 col-xl-12"/>
              <EditableInputViolation v-else class="col-lg-12 col-xl-12"/>
            </div>
            <DisputeTimeline class="col-lg-12 col-xl-12" />
            <EditableMVFileRecord :lgu_has_speed_violation="[2,5,6]" class="col-lg-12 col-xl-12" />
            <!-- <NovViewer :refresh_btn="true"/> -->
            <SaveOrReject :phase_id="props.phase_id" />
        </div>
      </b-overlay>
    </form>
    <div class="container" v-else-if="phases && phases.length === 0">
      <div class="row justify-content-center">
        <div class="col-md-10 col-lg-8">
            <div class="card p-3 text-center">
            <div class="card-body">
              <h3 class="">Operation not permitted</h3>
              <p>You don't have permission to access this phase. Please contact your administrator.</p>
              <img width="250" class="img-responsive" src="@/assets/images/stop.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="loading">
      <div class="row justify-content-center">
        <div class="col-md-10 col-lg-8">
            <div class="card p-3">
            <div class="card-body row justify-content-center">
              <div class="col-md-1">
                <img width="50" src="@/assets/images/animated-traffic-light.gif" />
              </div>
              <div class="offset-1 col-md-6">
                  <h3>{{ isSubmitted ? 'Saving...' : 'Loading...' }} <b-spinner :variant="info"></b-spinner></h3>
                  <p>This loading may take longer than usual {{ isSubmitted ? '' : ', please wait or click the "Refresh" button  ' }}</p>
                  <button :disabled="isSubmitted" @click="reloadPage" class="btn btn-secondary rounded-pill waves-effect waves-light">
                    <i class="mdi mdi-refresh"></i>
                    Refresh
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</Layout>
</template>
